import React, { useState, useEffect } from "react";

function AdminPurchases() {
  const [purchases, setPurchases] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch("https://auth.fnrewards.com/api/admin/purchases", {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => setPurchases(data.purchases))
      .catch(err => setError(err.message));
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h1>Purchase History</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <table border="1" cellPadding="10">
        <thead>
          <tr>
            <th>User email</th>
            <th>Product</th>
            <th>Time</th>
            <th>Quantity</th>
            <th>Price (credits)</th>
          </tr>
        </thead>
        <tbody>
          {purchases.map((purchase) => (
            <tr key={purchase.id}>
              <td>{purchase.user_email}</td>
              <td>{purchase.product_name}</td>
              <td>{new Date(purchase.purchase_date).toLocaleString()}</td>
              <td>{purchase.quantity}</td>
              <td>{purchase.total_price}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminPurchases;
